"use strict";

!function (v, T, t, i) {
  v("<link>").attr({
    rel: "stylesheet",
    href: "https://ms6.xhd.cn/r/cms/static/listen/listen.css"
  }).appendTo("head");
  var s = "listenFormS",
      e = {
    siteId: 3,
    contentName: "",
    submitTarget: ".submit",
    emailRequired: !1,
    courseRequired: !1,
    cityRequired: !1,
    isMsg: !1,
    smsInfo: "【新航道】",
    delay: 3e3
  };

  function n(t, i) {
    this.$ele = t, this.opts = v.extend({}, e, i), this.submitClick();
  }

  n.prototype = {
    charToInt: function charToInt(t) {
      if (null == t || "" == t) return "";
      var i = {},
          s = "";
      i[0] = t.charAt(0), s = i[0].charCodeAt();

      for (var e = 1; e < t.length; e++) {
        i[e] = t.charAt(e), s = s + "," + i[e].charCodeAt();
      }

      return s;
    },
    required: function required(t, i) {
      return i = i || "此项必填", !/^\s*$/g.test(t) || (this.msgTips(i), !1);
    },
    validateName: function validateName(t) {
      return this.commonValidate(t, /^[\u4E00-\u9FA5\uf900-\ufa2d·s]{2,20}$/, "请输入中文名字");
    },
    validatePhone: function validatePhone(t) {
      return this.commonValidate(t, /^1\d{10}$/, "请输入正确的手机号码");
    },
    commonValidate: function commonValidate(t, i, s) {
      return "" === t || !!i.test(t) || (this.msgTips(s), !1);
    },
    getListenName: function getListenName() {
      var t = this.opts.contentName,
          s = "";
      return "string" == typeof t ? s = t : t instanceof Array && v.each(t, function (t, i) {
        T.location.search === i.search && (s = i.name);
      }), s;
    },
    validateLinsten: function validateLinsten() {
      var t = !1,
          i = this.$ele,
          s = this.opts.siteId,
          e = this.opts.emailRequired,
          n = this.opts.courseRequired,
          a = this.opts.cityRequired,
          o = this.opts.isMsg,
          r = this.opts.smsInfo,
          c = v(i).find("[name='name']").val(),
          u = v(i).find("[name='phone']").val(),
          h = v(i).find(".email_input").val() || "",
          d = v(i).find("[name='course']").val() || "",
          m = v(i).find("[name='city']").val() || "";
      t = this.required(c, "请输入姓名") && this.validateName(c) && this.required(u, "请输入手机号码") && this.validatePhone(u), n && (t = t && this.required(d, "请选择您想预约的课程")), a && (t = t && this.required(m, "请选择您的所在城市")), e &&(t = t && this.required(h, "请输入拟申请国家/地区"));
      var l = this.getListenName(),
          f = {
        siteId: s,
        contentName: this.charToInt(l),
        name: this.charToInt(c),
        phoneNo: this.charToInt(u),
        email: this.charToInt(h),
        course: this.charToInt(d + "-" + h),
        city: this.charToInt(m),
        origin: T.location.href
      },
          p = {
        isSms: 0,
        info: this.charToInt(r)
      };
      o && (f = v.extend({}, f, p)), t && this.submitLinsten(f);
    },
    successFun: function successFun(t) {
      t.success ? this.msgTips("恭喜您预约成功！", "success", 3e3) : 3 == t.status ? this.msgTips("您已经预约，我们会尽快与您取得联系！") : this.msgTips("预约提交失败，请重试！");
    },
    submitLinsten: function submitLinsten(t) {
      var i = this,
          s = i.opts.successFun;
      v.ajax({
        type: "GET",
        url: "https://ms6.xhd.cn/listen.jspx",
        data: t,
        dataType: "jsonp",
        jsonp: "callbak",
        success: function success(t) {
          s && "function" == typeof s ? s() : i.successFun(t);
        },
        error: function error(t) {
          i.msgTips("服务器异常");
        }
      });
    },
    submitClick: function submitClick() {
      var i = this,
          t = i.opts.submitTarget,
          s = i.opts.delay,
          e = 0;
      v(t).on("click", function () {
        var t = new Date().getTime();
        s < t - e && (e = t, i.validateLinsten());
      });
    },
    msgTips: function msgTips(t, i, s) {
      var e = (s = s || 2e3) + 500,
          n = "";
      n = "success" === i ? '<div id="msgTips" class="success">' + t + "</div>" : '<div id="msgTips">' + t + "</div>", v("body").append(n), setTimeout(function () {
        v("#msgTips").addClass("fade-in");
      }, 0), setTimeout(function () {
        v("#msgTips").removeClass("fade-in");
      }, s), setTimeout(function () {
        v("#msgTips").remove();
      }, e);
    }
  }, v.fn[s] = function (t) {
    return this.each(function () {
      v.data(this, s) || v.data(this, s, new n(this, t));
    }), this;
  };
}(jQuery, window, document);
//# sourceMappingURL=map/listen.js.map
